export enum DropdownTypes {
  DEFAULT_WITH_IMAGE = 'Default',
}

export interface DropDownProps {
  type?: DropdownTypes
  placeHolder: string
  onChange: (value: number[] | string, position?: { left: number; top: number }) => void
  data: any
  fieldName?: string
  setFieldValue?: (field: string, value: string | number) => void
  hide?: boolean
  onButtonPress?: (fileFormatType: string) => void
  buttonLabel?: string
  label: string
}

export interface itemSelected {
  id: number
  value: string
}

export interface DropDownBoxInterface {
  showBorder?: boolean
  onLayout?: (value: Object) => void
  toggleDropdown: (val: boolean) => void
  defaultLabel: string
  dropdownVisible: boolean
  type: DropdownTypes
  value: string
  label?: string
  placeholder: string
}
